import { gql } from "@apollo/client";

export const GET_VENDORS = gql`
  query GetVendors {
    vendors {
      id
      userId
      shopId
      businessName
      email
      phone
      address
    }
  }
`;

export const GET_SHOPS = gql`
  query GetShops {
    shops {
      id
      vendorId
      shopName
      rating
      shopLogo
      followers
    }
  }
`;
